import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { Loader } from '@gem/ui-kit';

import { List } from 'APP/components/List/List';
import { SharedDataType } from 'APP/constants/sharedData';

import { useSharedDataPresenter } from '../SharedData.presenter';
import styles from '../SharedData.styles.m.css';
import { EmptyContentStub } from '../components/EmptyContentStub/EmptyContentStub';
import { GroupByDateItems } from '../components/GroupByDateItems';
import { LinkItem } from './LinkItem/LinkItem';

export const Links = observer(({ className, groupId }) => {
  const presenter = useSharedDataPresenter({
    groupId,
    type: SharedDataType.Links,
  });
  const { t } = useTranslation();

  return (
    <List
      isLoading={presenter.isLoading}
      className={classNames(styles.container, className)}
      data={presenter.dateList}
      hasMore={presenter.hasMore}
      onEndReached={presenter.loadMore}
      keyExtractor={(date) => date}
      renderItem={(date) => (
        <GroupByDateItems
          key={date}
          title={date}
          data={presenter.groupFilesByDate[date]}
          groupId={groupId}
          sharedDataType={SharedDataType.Links}
          renderItem={(item) => (
            <LinkItem
              key={`${item.id}_${item.messageId}`}
              {...item}
            />
          )}
        />
      )}
      SpinnerComponent={
        <div className={styles.loader}>
          <Loader color={'base'} />
        </div>
      }
      ListEmptyComponent={<EmptyContentStub noMediaText={t('shared_media_no_photo_video')} />}
    />
  );
});
